var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1161,
    height: 850,
    viewBox: "0 0 1161 850",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_1509_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1136.47 787.286C1135.77 789.957 1133.04 791.557 1130.37 790.859L1086.83 779.482C1084.16 778.783 1082.56 776.052 1083.25 773.38C1083.95 770.708 1086.68 769.108 1089.36 769.807L1128.06 779.92L1138.17 741.22C1138.87 738.548 1141.6 736.948 1144.27 737.646C1146.94 738.344 1148.54 741.076 1147.85 743.748L1136.47 787.286ZM74.8572 332.102L71.1106 335.413L74.8572 332.102ZM289.11 469.145L287.675 473.935L289.11 469.145ZM700.41 515.308L700.215 520.305L700.41 515.308ZM1120.6 767.191L1116.29 769.718L1120.6 767.191ZM469.236 506.284L469.431 501.288L469.236 506.284ZM342.772 485.221L344.206 480.431L342.772 485.221ZM60.3121 315.643L56.5655 318.954L60.3121 315.643ZM239.751 9.58289L214.143 17.9491L211.038 8.44349L236.645 0.0773287L239.751 9.58289ZM162.928 34.6814L137.321 43.0475L134.215 33.542L159.823 25.1758L162.928 34.6814ZM137.321 43.0475C124.867 47.1161 113.286 52.4585 102.647 58.866L97.488 50.2997C108.772 43.5035 121.042 37.8456 134.215 33.542L137.321 43.0475ZM48.5182 111.705C34.7977 133.23 26.1177 157.701 23.2077 183.061L13.2729 181.921C16.3559 155.054 25.5496 129.135 40.0855 106.33L48.5182 111.705ZM31.9435 258.198C36.1672 269.878 41.7932 281.323 48.8994 292.33L40.4983 297.754C32.9814 286.112 27.0194 273.987 22.5395 261.599L31.9435 258.198ZM48.8994 292.33C50.0352 294.089 51.2038 295.826 52.4043 297.541L44.2131 303.277C42.9407 301.46 41.7022 299.619 40.4983 297.754L48.8994 292.33ZM59.9893 307.549C61.3153 309.168 62.672 310.763 64.0587 312.332L56.5655 318.954C55.0957 317.291 53.6578 315.601 52.2524 313.884L59.9893 307.549ZM64.0587 312.332L67.695 316.447L60.2018 323.069L56.5655 318.954L64.0587 312.332ZM74.9676 324.676L78.6038 328.791L71.1106 335.413L67.4743 331.298L74.9676 324.676ZM78.6038 328.791C85.6518 336.766 92.9598 344.476 100.512 351.91L93.4967 359.036C85.7797 351.44 78.3122 343.562 71.1106 335.413L78.6038 328.791ZM148.873 393.313C165.933 405.977 183.853 417.44 202.503 427.618L197.713 436.395C178.656 425.995 160.345 414.283 142.912 401.343L148.873 393.313ZM260.369 454.16C270.286 457.899 280.349 461.301 290.545 464.355L287.675 473.935C277.257 470.814 266.974 467.338 256.841 463.517L260.369 454.16ZM290.545 464.355L303.96 468.374L301.09 477.954L287.675 473.935L290.545 464.355ZM330.791 476.412L344.206 480.431L341.337 490.01L327.921 485.991L330.791 476.412ZM344.206 480.431C354.376 483.478 364.631 486.2 374.957 488.597L372.696 498.338C362.166 495.894 351.707 493.117 341.337 490.01L344.206 480.431ZM437.694 499.046C448.239 500.126 458.823 500.874 469.431 501.288L469.041 511.281C458.223 510.858 447.429 510.095 436.675 508.994L437.694 499.046ZM469.431 501.288L527.225 503.544L526.835 513.536L469.041 511.281L469.431 501.288ZM642.811 508.056L700.605 510.312L700.215 520.305L642.421 518.049L642.811 508.056ZM700.605 510.312C715.005 510.874 729.301 512.035 743.461 513.777L742.24 523.702C728.355 521.994 714.336 520.856 700.215 520.305L700.605 510.312ZM827.545 531.345C855.125 539.562 881.878 550.052 907.541 562.657L903.132 571.633C877.967 559.272 851.734 548.986 824.69 540.928L827.545 531.345ZM981.219 606.824C1004.43 623.516 1026.29 642.167 1046.54 662.619L1039.43 669.654C1019.58 649.6 998.144 631.311 975.381 614.943L981.219 606.824ZM1101.66 728.499C1109.87 740.167 1117.63 752.228 1124.92 764.664L1116.29 769.718C1109.15 757.522 1101.53 745.695 1093.48 734.254L1101.66 728.499ZM1124.92 764.664L1127.67 769.372L1119.04 774.425L1116.29 769.718L1124.92 764.664ZM1133.19 778.787L1135.94 783.495L1127.32 788.548L1124.56 783.841L1133.19 778.787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_1509_98",
    x: 0.272949,
    y: 0.0772705,
    width: 1160.74,
    height: 848.946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1509_98"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1509_98",
    result: "effect2_dropShadow_1509_98"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1509_98",
    result: "effect3_dropShadow_1509_98"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1509_98",
    result: "effect4_dropShadow_1509_98"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1509_98",
    result: "effect5_dropShadow_1509_98"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1509_98",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/Line 2.9918364be04f8545d6008f92d6e84c2e.svg";
export { ForwardRef as ReactComponent };